var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "permission",
              rawName: "v-permission",
              value: "documents.create",
              expression: "'documents.create'"
            },
            {
              name: "ripple",
              rawName: "v-ripple.400",
              value: "rgba(255, 255, 255, 0.15)",
              expression: "'rgba(255, 255, 255, 0.15)'",
              modifiers: { "400": true }
            }
          ],
          attrs: { variant: "primary" },
          on: { click: _vm.addNew }
        },
        [
          _c("feather-icon", {
            staticClass: "mr-50",
            attrs: { icon: "PlusIcon" }
          }),
          _c("span", { staticClass: "align-middle" }, [
            _vm._v(_vm._s(_vm.$t("AddNew")))
          ])
        ],
        1
      ),
      _c("Grid", {
        ref: "grid",
        attrs: { service: _vm.service, route_name: "documents" },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function(actions) {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-row gap-2" },
                  [
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "documents.edit",
                          expression: "`documents.edit`"
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: {
                            content: "Editar",
                            delay: { show: 100, hide: 100 }
                          },
                          expression:
                            "{\n            content: 'Editar',\n            delay: { show: 100, hide: 100 }\n          }",
                          modifiers: { top: true }
                        }
                      ],
                      staticClass:
                        "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                      attrs: { icon: "EditIcon" },
                      on: {
                        click: function($event) {
                          return _vm.edit(actions.row.id)
                        }
                      }
                    }),
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "documents.detail",
                          expression: "'documents.detail'"
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: {
                            content: "Detalhar",
                            delay: { show: 100, hide: 100 }
                          },
                          expression:
                            "{\n            content: 'Detalhar',\n            delay: { show: 100, hide: 100 }\n          }",
                          modifiers: { top: true }
                        }
                      ],
                      staticClass:
                        "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                      attrs: { icon: "EyeIcon" },
                      on: {
                        click: function($event) {
                          return _vm.detail(actions.row.id)
                        }
                      }
                    }),
                    actions.row.filesCount > 0
                      ? _c("feather-icon", {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: "documents.download_all",
                              expression: "'documents.download_all'"
                            },
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top",
                              value: {
                                content: "Baixar todos os documentos anexados",
                                delay: { show: 100, hide: 100 }
                              },
                              expression:
                                "{\n              content: 'Baixar todos os documentos anexados',\n              delay: { show: 100, hide: 100 }\n            }",
                              modifiers: { top: true }
                            }
                          ],
                          staticClass:
                            "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                          attrs: { icon: "DownloadIcon" },
                          on: {
                            click: function($event) {
                              return _vm.downloadAll(
                                actions.row.id,
                                actions.row.title
                              )
                            }
                          }
                        })
                      : _vm._e(),
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "documents.delete",
                          expression: "`documents.delete`"
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: {
                            content: "Excluir",
                            delay: { show: 100, hide: 100 }
                          },
                          expression:
                            "{\n            content: 'Excluir',\n            delay: { show: 100, hide: 100 }\n          }",
                          modifiers: { top: true }
                        }
                      ],
                      staticClass:
                        "h-5 w-5 mb-1 mr-1 stroke-current text-danger",
                      attrs: { icon: "Trash2Icon" },
                      on: {
                        click: function($event) {
                          return _vm.destroy(actions.row)
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }